module.exports = __webpack_public_path__ + "media/images/official/about_yamori_mobara-987d574c93f30664dbf7cc5401bd9a5e.png";